import React from "react";

const TablePlanItem = ({ tableName, specialClasses, nameTag, id, onAction }) => {
    const onClickHandler = () => {
        onAction(id);
    };

    return (
        <div
            data-id={id}
            className={tableName + " flex justify-center items-center cursor-pointer"}
            onClick={onClickHandler}
        >
            <div
                className={
                    specialClasses + " flex justify-center items-center text-2xl uppercase mx-auto"
                }
            >
                {nameTag}
            </div>
        </div>
    );
};

export default TablePlanItem;
